<div class="nw_list__container is-fullwidth">
  <div class="nw_list__container__col">
    <div class="nw_list__page-header aligned-center">
      <h1 class="nw_list__page-header__title">News Listing</h1>
      <h2 class="nw_list__page-header__subtitle"></h2>
    </div>
    <div
      class="nw_list__react-wrap nw_list__react-wrap--news-list"
      data-endpoint-news="/api/sitecore/NewsApi/NewsListing"
      data-total-results="4"
      id="news-list"
    >
      <div>
        <div>
          <ul class="nw_list__latest-news__list on-landing-page" aria-live="polite">
            <li class="nw_list__latest-news__item" *ngFor="let news of newsData">
              <a (click)="routeToNewsDetails(news.id, news.shortTitle)" class="nw_list__latest-news__link">
                <figure class="nw_list__latest-news__image nw_list__ar-380x290">
                  <img
                    data-src="{{
                      news.imageDetails1?.src ? news.imageDetails1?.src : '../../../../../assets/images/default-img.png'
                    }}"
                    alt="{{ news.imageDetails1?.alt }}"
                    data-object-fit="cover"
                    class="loaded"
                    data-was-processed="true"
                  />
                </figure>
                <div class="nw_list__sub-heading nw_list__latest-news__title" role="heading" aria-level="2">
                  {{ news.title }}
                  <p class="nw_list__latest-news__posteddate">{{ news.publishedDate | date: 'MM-dd-yyyy' }}</p>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
